//
import { mapActions } from "vuex"
import { ModelForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"

//
import RoleModel from "@/models/Role"
import fields from "./fields"

//
export default {
    name: "role-update",
    components: {
        "model-form": ModelForm,
    },
    computed: {

        fieldsProps() {
            return {
                role_id: this.formData.id,
                selected_permissions_trigger: this.submit,
            }
        },

        /**
         * 
         */
        formProps () {
            return {
                editable: true,
                fields: fields(this.fieldsProps),
                switchEdit: true,
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setAppToolbarTitle: "setAppToolbarTitle",
        }),

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( RoleModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "role-list" })
        },

        /**
         * 
         */
        refresh () {
            this.reset()
        },

        /**
         * 
         */
        reset () {
            RoleModel.modeler().find( this.$route.params.id ).then( this.setFormData )
        },

        /**
         * 
         */
        setFormData ( model ) {
            this.formData = model.reset()
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.update )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Rol actualizado." )
        },

        /**
         * 
         */
        update ( model ) {
            model.toUpdate().save().then( this.success ).then( this.refresh ).catch( this.error ).then( this.$refs.form.setWait )
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: "Datos de rol" })
    },
    mounted () {
        this.reset()
    }
}